import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import ButtonOptionGroup from '../../component/ButtonOptions/ButtonOption';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBox, faBoxArchive, faBoxOpen, faCartPlus, faCartShopping, faTag } from '@fortawesome/free-solid-svg-icons';
import { FaSalesforce } from 'react-icons/fa';
import Tab from '../../../../component/Tabs/Tab';
import DataTableDynamic from '../../../../component/Table/DataTableDynamic';

const DetailProduct = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [keys, setKeys] = useState([]);
    const [columns, setColumns] = useState([]);
    const [detailData, setDetailData] = useState(null);
    
    const [dataTransaction, setDataTransaction] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_PRODUCT = "api/erpppsu/product";
    const PATH_PRODUCT_TRANSACTION = "api/erpppsu/product/transaction";

    const [activeType, setActiveType] = useState("transaction-product");
    const tabHeader = [
        {
            "key": "transaction-product",
            "label": "Transaksi Produk",
        }
    ];

    const fetchData = async (URL) => {
        try {
            const response = await axios.get(URL);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) {
            fetchData(`${BASE_URL}${PATH_PRODUCT}/detail?id=${id}`,).then((detail) => {
                setDetailData(detail)
            });
        }
    }, [id]);

    useEffect(() => {
        if (activeType == 'transaction-product') {
            fetchData(`${BASE_URL}${PATH_PRODUCT_TRANSACTION}?id=${id}`).then((transaction) => {
                setDataTransaction(transaction);
            });
        }
    }, [activeType]);

    useEffect(() => {
        setKeys(dataTransaction.length > 0 ? Object.keys(dataTransaction[0]) : []);
    }, [dataTransaction]);

    useEffect(() => {
        setColumns(keys.map(key => ({
            Header: key.charAt(0).toUpperCase() + key.slice(1),
            accessor: key
        })));
    }, [keys]);

    const handleTabClick = (tab) => {
        setActiveType(tab);
    };

    const options = [
        { value: 'edit-product', label: 'Edit' },
        { value: 'archive-product', label: 'Arsipkan' }
    ];

    return (
        <div className="p-6 bg-gray-50 font-sans">
            <h2 className="text-2xl font-bold mb-6">Detail produk</h2>

            <div className='flex items-center justify-between mb-5'>
                <h1>{detailData?.name}</h1>

                <div className='flex items-center'>
                    <ButtonOptionGroup
                        label={"Tindakan"}
                        options={options}
                        onChange={(value) => {
                            if (value == 'edit-product') {
                                navigate(`/activity-erpppsu/edit-product/${id}`);
                            } else if (value == 'add-warehouse') {
                            }
                        }}
                    />
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div className='flex flex-col flex-1'>
                    <div className='mb-2'>
                        <FontAwesomeIcon fontSize={24} icon={faBoxOpen} color="gray" />
                        <span className='font-bold text-center align-top m-2 text-gray-500 text-xl'>Info Produk</span>
                    </div>
                    <div className='flex'>
                        <p className="basis-1/2 text-sm">Kode Produk</p>
                        <p className="text-sm" >{detailData?.code ?? "-"}</p>
                    </div>
                    {/* <div className='flex'>
                        <p className="basis-1/2 text-sm">Barcode</p>
                        <p className="text-sm" >{detailData?.code ?? "-"}</p>
                    </div> */}
                    <div className='flex'>
                        <p className="basis-1/2 text-sm">Kategori produk</p>
                        <p className="text-sm" >{detailData?.category ?? "-"}</p>
                    </div>
                    <div className='flex'>
                        <p className="basis-1/2 text-sm">Deskripsi</p>
                        <p className="text-sm" >{detailData?.description ?? "-"}</p>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div className='flex flex-col flex-1'>
                    <div className='mb-2'>
                        <FontAwesomeIcon fontSize={24} icon={faCartShopping} color="gray" />
                        <span className='font-bold text-center align-top m-2 text-gray-500 text-lg'>Info Pembelian</span>
                    </div>
                    <div className='flex'>
                        <p className="basis-1/2 text-sm">Harga Beli Satuan</p>
                        <p className="text-sm" >Rp {parseFloat(detailData?.price_buy ?? 0).toLocaleString("id-ID")}</p>
                    </div>
                    <div className='flex'>
                        <p className="basis-1/2 text-sm">Akun Pembelian</p>
                        <p className="text-sm" >{detailData?.account_buy_name ?? "-"}</p>
                    </div>
                    <div className='flex'>
                        <p className="basis-1/2 text-sm">Pajak Beli</p>
                        <p className="text-sm" >{detailData?.account_taxt_buy_name ?? "-"}</p>
                    </div>
                </div>

                <div className='flex flex-col flex-1'>
                    <div className='mb-2'>
                        <FontAwesomeIcon fontSize={24} icon={faTag} color="gray" />
                        <span className='font-bold text-center align-top m-2 text-gray-500 text-lg'>Info Penjualan</span>
                    </div>
                    <div className='flex'>
                        <p className="basis-1/2 text-sm">Harga Jual Satuan</p>
                        <p className="text-sm" >Rp {parseFloat(detailData?.price_sell ?? 0).toLocaleString("id-ID")}</p>
                    </div>
                    <div className='flex'>
                        <p className="basis-1/2 text-sm">Akun Penjualan</p>
                        <p className="text-sm" >{detailData?.account_sell_name ?? "-"}</p>
                    </div>
                    <div className='flex'>
                        <p className="basis-1/2 text-sm">Pajak Jual</p>
                        <p className="text-sm" >{detailData?.account_taxt_sell_name ?? "-"}</p>
                    </div>
                </div>
            </div>

            <div>
                <div className="tabs">
                    {tabHeader.map((tab) => (
                        <Tab name={tab.key} label={tab.label} activeTab={activeType} onClick={() => {
                            handleTabClick(tab.key)
                        }} />
                    ))}
                </div>

                {loading ? (
                    <center><h1>Loading...</h1></center>
                ) : (
                    <DataTableDynamic
                        data={dataTransaction}
                        elementClass="p-1"
                        columns={columns}
                        moduleActions={[]}
                        enableCustom={false} />
                )}
            </div>
        </div>
    );
}

export default DetailProduct;
